<template>
<div class="div">
   <div class="modal-container">
    <button class="payment-button" @click.prevent="$emit('clicked')">
     Make Payment
    </button>
    <div class="dropdown-div" :class="{hide: modal }">
      <div class="dropdown-container" v-if="isToggled">
        <div class="dropdown-content"  >
          <p>You have already made a payment of N{{amountpaid}}. How much extra would you like to pay?</p>
          <input type="text" name="amount" id="amount" :value="amount" @input="$emit('input', $event.target.value)">
          <button class="button" :value="project_id" @click="$emit('pay', $event.target.value )">Pay</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
   data() {
    return {
      tog: false,
      modal: false,
    };
  },
  props: {
    toggled: {
      default: 0,
    },
    id: {
      default: 0,
    },
    amountpaid: {
      default: 0
    },
    amount: {
      default: null
    },
    project_id: {
      default: 0
    },
  },
  computed: {
    isToggled() {
      return this.toggled === this.id;
    },
  }
  
};
</script>

<style scoped>
.hide{
  visibility: hidden;
}
.dropdown-container {
  position: absolute;
  z-index: 1;
  width: auto;
  right: 3em;
  margin-top: 10px;
  overflow: hidden;
  background: #ffffff;
}
.dropdown-container::before {
  content: "";
  position: absolute;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid white;
  right: 0;
  z-index: 10;
  /* margin-top: -10px; */
}
.dropdown-content {
  padding: 10px;
  font-size: 12px;
}
.dropdown-content p{
  width: 90%;
}

.payment-button {
  appearance: button;
  background-color: #1652F0;
  border: 1px solid #1652F0;
  border-radius: 4px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.15;
  overflow: visible;
  padding: 12px 16px;
  position: relative;
  text-align: center;
  text-transform: none;
  transition: all 80ms ease-in-out;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: fit-content;
}

.payment-button:disabled {
  opacity: .5;
}

.payment-button:focus {
  outline: 0;
}

.payment-button:hover {
  background-color: #0A46E4;
  border-color: #0A46E4;
}

.payment-button:active {
  background-color: #0039D7;
  border-color: #0039D7;
}
</style>